// extracted by mini-css-extract-plugin
module.exports = {"date-range-select":"styles-module__date-range-select___1Bdd4"};